export const indicadoresBancarioConfig = [
    { key: "match100", text: "Match 100%", icon: "check_circle" },
    { key: "matchMenor100", text: "Match < 100%", icon: "pending" },
    { key: "noMatch", text: "No Match", icon: "cancel" },
    { key: "confirmados", text: "Confirmados", icon: "task_alt" },
    { key: "aProcesar", text: "A Procesar", icon: "hourglass_empty" },
    { key: "conError", text: "Con Error", icon: "error" },
    { key: "descartados", text: "Descartados", icon: "delete" },
];
